import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
    EditableSlideToggle,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffPeikShiftsEdit from '../peik/TaroffPeikShiftsEdit';
import { postData } from '../../Api';

export default function TarottPeikShifts(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        applyFilters();
    };
    const handlecomp2 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQTitle('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    useEffect(() => {
        postData('/api/panel/page/tarott-peik-shifts/table-data', {
            size: tableSize,
            page: tablePage,
            q_title: filterQTitle,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp3 = (row) => {
        alert('error in editting slide-toggle value')
    };
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffPeikShiftsEdit
                        taroff-peik-shifts-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Title>شیفت های ارسال پیک</Title>
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <Button onClick={handlecomp1} color={'secondary'}>
                جستجو
            </Button>
            <Row>
                <RightComponents>
                    <Title>شیفت های ارسال پیک</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>فعال</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>شرح</TableColumn>
                        <TableColumn mobile={false}>زمان مجاز ثبت سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <EditableSlideToggle onChange={() => handlecomp3(row)} />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_description}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text}</TextView>
                                    <TextView bold={true} format={'persian-datetime-normal'}>
                                        {row.text_beginning}
                                    </TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView bold={true} format={'persian-datetime-normal'}>
                                        {row.text_end}
                                    </TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp4(row)}
                                    rightIcon={'far fa-edit'}
                                    tooltip={'ویرایش'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
